/**
 * Whether a fee schedule category charges for the vendor's work or passes through a cost (#6864).
 *
 * Both take the same rates and units. The type decides only whether an hourly rate must name who
 * bills it. The API sends the member name, the same way it sends a currency.
 */
export enum FeeScheduleCategoryType {
  Fee = "Fee",
  Expense = "Expense",
}

/**
 * What a category reads as when the API sent no type. Every category saved before the type existed
 * is a fee: the migration made every stored row one, and a negotiation event recorded before then
 * replays as one.
 */
export const DEFAULT_FEE_SCHEDULE_CATEGORY_TYPE = FeeScheduleCategoryType.Fee;

/** The word a reader sees for a type, in a table cell, a redline or the editor's choice. */
export function feeScheduleCategoryTypeLabel(type: FeeScheduleCategoryType): string {
  return type === FeeScheduleCategoryType.Expense ? "Expense" : "Fee";
}
